enum CartStatusEnum {
    DRAFT = "DRAFT",
    PAYMENT_PENDING = "PAYMENT_PENDING",
    PENDING = "PENDING",
    PROCESSED = "PROCESSED",
    PAYMENT_ERRORED = "PAYMENT_ERRORED",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED",
}

export default CartStatusEnum;
